
import React, { PureComponent } from 'react';

// import { openDialog } from '../../base/dialog';
import { translate } from '../../base/i18n';
import { getParticipantCount } from '../../base/participants';
import { connect } from '../../base/redux';
import { iAmVisitor } from '../../visitors/functions';

// import { SpeakerStats } from './';

/**
 * The type of the React {@code Component} props of {@link SpeakerStatsLabels}.
 */
type Props = {

    /**
     * The conference object.
     */
    _conference: Object,

    /**
     * The participant count.
     */
    _count: number,

    /**
     * Whether the current user is a visitor.
     */
    _iAmVisitor: boolean,

    /**
     * Whether speaker stats is disabled.
     */
    _isSpeakerStatsDisabled: boolean,

    /**
     * The redux dispatch function.
     */
    dispatch: Function,

    /**
     * The function to translate human-readable text.
     */
    t: Function
};

/**
 * React component for labeling speaker stats column items.
 *
 * @augments Component
 */
class SpeakerStatsLabels extends PureComponent<Props> {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { t } = this.props;

        return (
            <div className = 'speaker-stats-item__labels'>
                <div className = 'speaker-stats-item__status' />
                <div className = 'speaker-stats-item__name'>
                    { t('speakerStats.name') }
                </div>
                <div className = 'speaker-stats-item__time'>
                    { t('speakerStats.speakerTime') }
                </div>
            </div>
        );
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code SpeakerStatsLabels} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state) {
    const conference = state['features/base/conference'].conference;
    let count = getParticipantCount(state);
    const iAmVisitorState = iAmVisitor(state);
    const _isSpeakerStatsDisabled = false; // You can add the actual selector here if it exists

    // Visitor has hidden its own video and should not count itself
    if (iAmVisitorState) {
        count--;
    }

    return {
        _conference: conference,
        _count: count,
        _iAmVisitor: iAmVisitorState,
        _isSpeakerStatsDisabled
    };
}

export default translate(connect(mapStateToProps)(SpeakerStatsLabels));
